/**
 * Created by iraphael on 12/22/18.
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');
    var NumericDropdownViewController = require('web-agent-components/NumericDropdownViewController');

    var FilterItemDropdownNumericRange = BaseFilterItem.extend({
        LPTemplatesFiles: {
            numericRangeItem: 'LP_filter_full_table_dropdown_numeric_range.html'
        },
        LPClassesMap: {
            startInput: ".start",
            endInput: ".end",
            tableContainer: ".list_table_container",
            error: "error"
        },
        LPViewMap: {
            toView: ".end"
        },

        initialize: function (constructorData) {
            var numericTemplate = require('web-agent-templates/' + this.LPTemplatesFiles.numericRangeItem);
            this.view  = this.createView({template: numericTemplate});
            this.nullElement = {text: "-", type: 0};
            this.defaultFilterUIData = lpUtils.cloneObject(constructorData.defaultFilter || {from: this.nullElement, to: this.nullElement});
            this.filterUIData = lpUtils.cloneObject(constructorData.defaultFilter || {from: lpUtils.cloneObject(this.nullElement), to: lpUtils.cloneObject(this.nullElement)});
            this.config = constructorData;
            this.startValueUnits = [];
            this.endValueUnits = [];
            this.valueText2Type = new Map();
            this.valueText2Type.set('from', new Map());
            this.valueText2Type.set('to', new Map());
            this.valid = true;

            initValuesArray(this.startValueUnits, this.valueText2Type.get('from'), this.config.startMinValue, this.config.startMaxValue, this.nullElement);
            initValuesArray(this.endValueUnits, this.valueText2Type.get('to'), this.config.endMinValue, this.config.endMaxValue, this.nullElement);

            function initValuesArray(array, valueText2Type, startValue, endValue, nullElement) {
                var numOfValues = endValue - startValue;
                array.push(nullElement);
                valueText2Type.set(nullElement.text, nullElement.type);
                var arrayElement;
                for(var i = 0 ; i <= numOfValues ; ++i) {
                    arrayElement = {text: (i + startValue).toString(), type: (i + 1)};
                    array.push(arrayElement);
                    valueText2Type.set(arrayElement.text, arrayElement.type);
                }
            }
        },
        events: function () {
        },
        render: function () {
            this.startValueVC = createVC(this, this.startValueUnits, 'from',this.LPClassesMap.startInput);
            this.endValueVC = createVC(this, this.endValueUnits, 'to',this.LPClassesMap.endInput);

            function createVC(self, items, target, targetClass) {
                var valueVC = new NumericDropdownViewController({
                    items: items,
                    selectedIndex: 0,
                    context: self,
                    textProperty: "text",
                    scrollableContainer: self.LPClassesMap.tableContainer,
                    valueChangedCallback: self._onValueChanged.bind(self, target),
                    lostFocusCallback: self._onFocusChanged.bind(self, target)
                });
                self.addViewController({viewController: valueVC, target: targetClass});
                return valueVC;
            }
        }
    });

    FilterItemDropdownNumericRange.prototype.setValidationFailedHook = function (validationFailedHook) {
        this.validationFailedHook = validationFailedHook;
    };

    FilterItemDropdownNumericRange.prototype.setValidationFailureRecoverHook = function (validationFailureRecoverHook) {
        this.validationFailureRecoverHook = validationFailureRecoverHook;
    };

    /**
     * @override
     */
    FilterItemDropdownNumericRange.prototype.getValue = function() {

        if(!this.filterUIData.from && !this.filterUIData.to){
            return;
        }

        return {
            from: this.resolveValue(this.filterUIData.from),
            to: this.resolveValue(this.filterUIData.to),
        };
    };

    FilterItemDropdownNumericRange.prototype.resolveValue = function (value) {
        if(_.isUndefined(value) || value.text === this.nullElement.text) {
            return;
        }
        return value;
    };

    /**
     * @override
     */
    FilterItemDropdownNumericRange.prototype.updateFilterUI = function (filterUIData) {
        this.filterUIData = lpUtils.cloneObject(filterUIData || this.defaultFilterUIData);

        this.filterUIData.from = updateFilterUIData(this, this.filterUIData.from);
        this.filterUIData.to = updateFilterUIData(this, this.filterUIData.to);

        updateUI(this, 'from', this.startValueVC, this.filterUIData.from);
        updateUI(this, 'to', this.endValueVC, this.filterUIData.to);

        function updateFilterUIData(self, targetFilterUIData) {
            if(_.isUndefined(targetFilterUIData) || _.isNaN(targetFilterUIData.text) || !_.isNumber(targetFilterUIData.text)) {
                return lpUtils.cloneObject(self.nullElement);
            } else {
                return targetFilterUIData;
            }
        }

        function updateUI(self, target, vc, targetFilterUIData) {
            self._onValueChanged(target, targetFilterUIData.text);
            vc.setSelectedIndex(targetFilterUIData.type);
        }
    };

    /**
     * Callback for numeric field value change
     * @param {String} target start or end fields
     * @param {String} value
     * @private
     */
    FilterItemDropdownNumericRange.prototype._onValueChanged = function(target, value) {
        this.filterUIData[target].text = (_.isNumber(value) && !_.isNaN(value)) ? value : this.nullElement.text;
        this.filterUIData[target].type = this.valueText2Type.get(target).get(this.filterUIData[target].text.toString());
        this._validate();
    };

    /**
     * Callback for numeric field focus change
     * @param {String} target start or end fields
     * @param {String} value
     * @private
     */
    FilterItemDropdownNumericRange.prototype._onFocusChanged = function(target, event) {
        if(event.target.value === "") {
            this.filterUIData[target] = lpUtils.cloneObject(this.nullElement);
        }
    };

    /**
     * Validates that start in lower then end and updates end accordingly
     * @private
     */
    FilterItemDropdownNumericRange.prototype._validate = function() {
        if(_.isNumber(this.filterUIData.from.text) && _.isNumber(this.filterUIData.to.text)) {
            if(this.filterUIData.to.text < this.filterUIData.from.text) {
                this.updateStateAndViewClasses(false);
            } else if(!this.valid) {
                this.updateStateAndViewClasses(true);
            }
        } else if(!this.valid) {
            this.updateStateAndViewClasses(true);
        }
    };

    FilterItemDropdownNumericRange.prototype.updateStateAndViewClasses = function(valid) {
        this.valid = valid;
        if(valid) {
            this.removeClass(this.LPViewMap.toView, this.LPClassesMap.error);
            if(this.validationFailureRecoverHook) {
                this.validationFailureRecoverHook.call(this);
            }
        } else {
            this.addClass(this.LPViewMap.toView, this.LPClassesMap.error);
            if(this.validationFailedHook) {
                this.validationFailedHook.call(this);
            }
        }
        this.endValueVC.setShowValidationErrorBubble(!valid);
    };

    return FilterItemDropdownNumericRange;

});
